(function (angular) {
    'use strict';

    angular.module('broadcast')

        /**
         *
         */
        .factory('broadcastService',
            ['$http', '$q', 'portalConfig', 'channelsProvider',
                function ($http, $q, portalConfig, channelsProvider) {

                    var urlBase = portalConfig.urlBase;
                    //urlBase = 'http://localhost:8001';
                    var fac = {
                        getBroadcasts: getBroadcasts,
                        getBroadcastsHistory: getBroadcastsHistory,
                        getBroadcast: getBroadcast,
                        createBroadcast: createBroadcast,
                        updateBroadcast: updateBroadcast,
                        sendBroadcast: sendBroadcast,
                        scheduleBroadcast: scheduleBroadcast,
                        testBroadcast: testBroadcast,
                        deleteScheduledBroadcast: deleteScheduledBroadcast,
                        deleteBroadcast: deleteBroadcast
                    };

                    return fac;

                    function getBroadcastsHistory(id, from, to) {

                        var url = urlBase + "/apispaces/" + id + "/broadcasts/history";

                        if (from && to) {
                            url += "?from=" + from + "&to=" + to;
                        }

                        return $http.get(url)
                            .then(getBroadcastsHistoryComplete)
                            .catch(getBroadcastsHistoryFailed);

                        function getBroadcastsHistoryComplete(response) {
                            return response.data;
                        }

                        function getBroadcastsHistoryFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }
                    /**
                     * GET "/apispaces/{id}/broadcasts"
                     * @param {string} id - the api space Id
                     */
                    function getBroadcasts(id) {

                        return $http.get(urlBase + "/apispaces/" + id + "/broadcasts?status=draft&status=scheduled")
                            .then(getBroadcastsComplete)
                            .catch(getBroadcastsFailed);

                        function getBroadcastsComplete(response) {
                            return response.data;
                        }

                        function getBroadcastsFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    /**
                     * GET "/apispaces/{id}/broadcasts/{searchId}"
                     * @param {string} id - the api space Id
                     * @param {string} searchId - the profile Id
                     */
                    function getBroadcast(id, searchId) {

                        return $http.get(urlBase + "/apispaces/" + id + "/broadcasts/" + searchId)
                            .then(getBroadcastComplete)
                            .catch(getBroadcastFailed);

                        function getBroadcastComplete(response) {
                            return response.data;
                        }

                        function getBroadcastFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }
                    /**
                     * POST "/apispaces/{id}/broadcasts/"
                     * @param {string} id - the api space Id
                     * @param {string} data - data of broadcast to create
                     */
                    function createBroadcast(id, data) {
                        return $http.post(urlBase + "/apispaces/" + id + "/broadcasts", data)
                            .then(createBroadcastComplete)
                            .catch(createBroadcastFailed);

                        function createBroadcastComplete(response) {
                            return response.data;
                        }

                        function createBroadcastFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }
                    /**
                     * PUT "/apispaces/{id}/broadcasts/{searchId}"
                     * @param {string} id - the api space Id
                     * @param {string} data - data of broadcast to update
                     */
                    function updateBroadcast(id, data) {

                        return $http.put(urlBase + "/apispaces/" + id + "/broadcasts/" + data.id, data)
                            .then(updateBroadcastComplete)
                            .catch(updateBroadcastFailed);

                        function updateBroadcastComplete(response) {
                            return response.data;
                        }

                        function updateBroadcastFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }


                    function deleteBroadcast(id, broadcastId) {

                        return $http.delete(urlBase + "/apispaces/" + id + "/broadcasts/" + broadcastId)
                            .then(deleteBroadcastComplete)
                            .catch(deleteBroadcastFailed);

                        function deleteBroadcastComplete(response) {
                            return response.data;
                        }

                        function deleteBroadcastFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }
                    /**
                     * PUT "/apispaces/{id}/broadcasts/{broadcastId}"
                     * @param {string} id - the api space Id
                     * @param {string} broadcastId - the broadcast id
                     */
                    function sendBroadcast(id, broadcastId) {

                        return $http.post(urlBase + "/apispaces/" + id + "/broadcasts/" + broadcastId + "/send")
                            .then(sendBroadcastComplete)
                            .catch(sendBroadcastFailed);

                        function sendBroadcastComplete(response) {
                            return response.data;
                        }

                        function sendBroadcastFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }
                    function testBroadcast(id, broadcastId, options) {

                        return $http.post(urlBase + "/apispaces/" + id + "/broadcasts/" + broadcastId + "/test", options)
                            .then(testBroadcastComplete)
                            .catch(testBroadcastFailed);

                        function testBroadcastComplete(response) {
                            return response.data;
                        }

                        function testBroadcastFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }
                    function scheduleBroadcast(id, broadcastId, options) {

                        return $http.put(urlBase + "/apispaces/" + id + "/broadcasts/" + broadcastId + "/schedule", options)
                            .then(scheduleBroadcastComplete)
                            .catch(scheduleBroadcastFailed);

                        function scheduleBroadcastComplete(response) {
                            return response.data;
                        }

                        function scheduleBroadcastFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }
                    function deleteScheduledBroadcast(id, broadcastId) {

                        return $http.delete(urlBase + "/apispaces/" + id + "/broadcasts/" + broadcastId + "/schedule")
                            .then(deleteScheduledBroadcastComplete)
                            .catch(deleteScheduledBroadcastFailed);

                        function deleteScheduledBroadcastComplete(response) {
                            return response.data;
                        }

                        function deleteScheduledBroadcastFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }
                }]);
})(window.angular);
